// Diagnostic helper for routes.planned writes.
// Adds a build marker + thin wrapper around log_route_planned_write RPC.
// Used to identify which code path overwrote a v2 entry-aware route.

import { supabase } from '@/integrations/supabase/client';

export const ROUTE_V2_GUARD_BUILD_ID = '2026-06-17T19:30:00Z';

let bootMarkerPrinted = false;
export function printRouteGuardBootMarker(source: string) {
  if (bootMarkerPrinted) return;
  bootMarkerPrinted = true;
  // eslint-disable-next-line no-console
  console.info('route_v2_guard_build_marker', {
    source,
    buildId: ROUTE_V2_GUARD_BUILD_ID,
    ts: new Date().toISOString(),
  });
}

export type RoutePlannedWritePhase = 'attempt' | 'result' | 'blocked';

export interface RoutePlannedAuditNotes {
  existingVersion?: number | null;
  nextVersion?: number | null;
  existingOrderedTaskStopIdsCount?: number;
  nextOrderedTaskStopIdsCount?: number;
  manualGroups?: number;
  outboundGroups?: number;
  inboundGroups?: number;
  factoryBucketNullCount?: number;
  blocked?: boolean;
  blockReason?: string;
  [k: string]: unknown;
}

export async function logRoutePlannedWrite(args: {
  writerSource: string;
  routeId?: string | null;
  driverId: string;
  serviceDate: string;
  tenantId: string;
  phase: RoutePlannedWritePhase;
  notes?: RoutePlannedAuditNotes;
}) {
  const payload = {
    evt: 'route_planned_write',
    buildId: ROUTE_V2_GUARD_BUILD_ID,
    ...args,
    ...(args.notes ?? {}),
  };
  // eslint-disable-next-line no-console
  console.info('route_planned_write', payload);

  try {
    await supabase.rpc('log_route_planned_write', {
      _writer_source: args.writerSource,
      _route_id: args.routeId ?? null,
      _driver_id: args.driverId,
      _service_date: args.serviceDate,
      _tenant_id: args.tenantId,
      _phase: args.phase,
      _notes: (args.notes ?? {}) as any,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('route_planned_write_audit_log_failed', { error: (e as any)?.message });
  }
}

export function summarizePlanned(planned: any): RoutePlannedAuditNotes {
  if (!planned || typeof planned !== 'object') return {};
  const groups: any[] = Array.isArray(planned.stopGroups) ? planned.stopGroups : [];
  return {
    existingVersion: typeof planned.version === 'number' ? planned.version : null,
    existingOrderedTaskStopIdsCount: Array.isArray(planned.orderedTaskStopIds)
      ? planned.orderedTaskStopIds.length
      : 0,
    manualGroups: groups.filter((g) => g?.mergeMode === 'manual').length,
    outboundGroups: groups.filter((g) => g?.factoryFlowBucket === 'factory_start_outbound').length,
    inboundGroups: groups.filter((g) => g?.factoryFlowBucket === 'factory_end_inbound').length,
    factoryBucketNullCount: groups.filter(
      (g) => Object.prototype.hasOwnProperty.call(g ?? {}, 'factoryFlowBucket') && g.factoryFlowBucket == null,
    ).length,
  };
}
